'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _spec = require('../spec');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var range = function range(x) {
  return new Array(x).fill('').map(function (_, i) {
    return i + 1;
  });
};

var styles = {
  col: {
    boxSizing: 'border-box',
    flex: '0 0 auto',
    paddingRight: _spec.gutter / 2,
    paddingLeft: _spec.gutter / 2
  },
  reverse: {
    'flex-direction': 'column-reverse'
  }
};
var _size = function _size(i) {
  return Number(100 / _spec.columns * i).toFixed(4);
};

var helpers = {
  basic: {
    'flex-grow': 1,
    'flex-basis': 0,
    'max-width': '100%'
  },
  size: function size(i) {
    return {
      'flex-basis': _size(i) + '%',
      'max-width': _size(i) + '%'
    };
  },
  offset: function offset(i) {
    return {
      'margin-left': _size(i) + '%'
    };
  },
  first: {
    order: '-1'
  },
  last: {
    order: '1'
  }
};

Object.keys(_spec.breakpoints).forEach(function (breakpoint) {
  Object.keys(helpers).map(function (key) {
    return { key: key, helper: helpers[key] };
  }).forEach(function (_ref) {
    var key = _ref.key,
        helper = _ref.helper;

    if (key === 'size' || key === 'offset') {
      range(_spec.columns).forEach(function (colIndex) {
        styles[breakpoint + '-' + key + '-' + colIndex] = _defineProperty({}, (0, _spec.media)(breakpoint), helper(colIndex));
      });
    } else {
      var sKey = key === 'basic' ? breakpoint : breakpoint + '-' + key;
      styles[sKey] = _defineProperty({}, (0, _spec.media)(breakpoint), helper);
    }
  });
});

styles.noPadding = {
  padding: 0
};

exports.default = styles;


//////////////////
// WEBPACK FOOTER
// ../dist/col/styles.js
// module id = 122
// module chunks = 0